import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {BarbarianFuryGameConfig} from "../../BarbarianFuryGameConfig";
import {Elastic, TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {BarbarianFuryParsedGameData} from "../../server/data/BarbarianFuryParsedGameData";
import {BarbarianFuryParsedInitData} from "../../server/data/BarbarianFuryParsedInitData";
import {BarbarianFuryGameMode} from "../../gamemode/BarbarianFuryGameMode";

export class BFReelAreaView extends ReelAreaView {

    public static _reelAreaView: BFReelAreaView;
    private TimeLineLiteArr: TimelineLite[] = [];
    private _data: BarbarianFuryParsedGameData | BarbarianFuryParsedInitData;

    constructor(resourcesGroup?: ResourcesGroupName) {
        super(resourcesGroup);
        BFReelAreaView._reelAreaView = this;
        EventHandler.addEventListener(this, "teaseAborted", (event: GameEvent) => this.abortTease(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
    }

    public startTease(id: number, nudgeUp: boolean, stackedSpinTriggered: boolean, onCompleteCB: () => void): void {
        const position = BarbarianFuryGameConfig.instance.REEL_DISPLAY_POSITIONS[id];
        const symHeight: number = BarbarianFuryGameConfig.instance.SYMBOL_HEIGHT;

        let nudgingGap: number = nudgeUp ? 0.5 : -0.5,
            tween_init_pos: number = 0,
            tween_final_pos: number = 1.3,
            call_back_pos: number = 1.6;

        if (this._data.mode === BarbarianFuryGameMode.FREESPIN) {
            nudgingGap = 0;
            tween_final_pos = 0.25;
            call_back_pos = 0.5
        }

        let tween_initial: TweenLite,
            tween_final: TweenLite,
            tll_collection: TimelineLite | null;

        tween_initial = TweenLite.to(this._reelViews[id], 1, {
            y: position[1] + (nudgingGap * symHeight),
            ease: Elastic.easeOut.config(1, 10)
        });

        tween_final = TweenLite.to(this._reelViews[id], 0.3, {
            y: position[1]
        });

        tll_collection = new TimelineLite({autoRemoveChildren: true});

        tll_collection.add(tween_initial, tween_init_pos);
        tll_collection.add(tween_final, tween_final_pos);
        tll_collection.add(() => onCompleteCB(), call_back_pos);

        this.TimeLineLiteArr!.push(tll_collection);
    }

    private onDataParsed(data: BarbarianFuryParsedGameData | BarbarianFuryParsedInitData): void {
        this._data = data;
    }

    private abortTease(arr: any): void {
        for (let i = 0; i < this.TimeLineLiteArr!.length; i++) {
            this.TimeLineLiteArr![i]!.pause();
            this.TimeLineLiteArr![i]!.kill();
        }

        this.TimeLineLiteArr = [];

        for (let i = 0; i < arr.length; i++) {
            if (arr[i]) {
                this._reelViews[i].y = BarbarianFuryGameConfig.instance.REEL_DISPLAY_POSITIONS[i][1];
            }
        }
    }
}